<div mat-dialog-title>
  <div class="row row--space-between row--valign-center">
    <label class="semi-bold">{{ 'App.RequestPayment.Labels.Payment' | translate }}</label>
    <button mat-button (click)="closeBypassPayment()" class="float-right">
      <span class="icon-x"></span>
    </button>
  </div>
</div>

<!-- Supervisor Code Section -->
<div mat-dialog-content>
  <form [formGroup]="bypassPaymentForm">
    <div class="row column--12 display-column-flex row--valign-center row--no-gap mt--xs color--navy">
      <div class="row display-column-flex align-center">
        <span class="align-center">{{ 'App.RequestPayment.Labels.BypassWarning' | translate }}</span>
        <span class="text-medium bold mt--xs">{{ 'App.RequestPayment.Labels.SupervisorCode' | translate }}</span>
        <mat-form-field hideRequiredMarker appearance="outline">
          <mat-label>{{ 'App.RequestPayment.Placeholders.SupervisorCode' | translate }}</mat-label>
          <input matInput formControlName="supervisorCode" name="supervisorCode" value="" type="password" required />
          <mat-error>{{ 'App.RequestPayment.Labels.InvalidInput' | translate }} </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<!-- Buttons Section -->
<div class="row row--space-between" mat-dialog-actions>
  <button mat-button class="secondary-button column-lg--6 column-sm--12 column--12 rounded" (click)="closeBypassPayment()">
    <span class="icon-x mr--sm"></span>
    <span>{{ 'App.RequestPayment.Buttons.Cancel' | translate }}</span>
  </button>
  <button mat-button class="primary-button column-lg--6 column-sm--12 column--12 rounded" (click)="bypassPayment()">
    <span class="icon-check mr--sm"></span>
    <span>{{ 'App.RequestPayment.Buttons.BypassPayment' | translate }}</span>
  </button>      
</div>
